import { RG_TYPE } from '../../types/rg-type.js';

const DefaultBuilding = {
    type: RG_TYPE.Building,
    name: 'building',
    children: [],
    data: {
        index: -1,
        levels: [],
        anatomy: { pos: [0, 0, 0], bones: [], cornerFlip: false, id: '' }
    }
};

export { DefaultBuilding };
//# sourceMappingURL=default-building.js.map
